import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 22,
    height: 22
  }
});

class IcLinkedIn extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    titleAccess = 'Linkedin'
                    viewBox = { "0 0 22 22" } >
      <path d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z" fill="#007ab6"/>
      <path d="M7.77355 8.49956V15.9895H5.28071V8.49956H7.77355ZM7.93773 6.18261C7.93773 6.90179 7.39639 7.47725 6.52718 7.47725H6.51125C5.67434 7.47725 5.1333 6.90179 5.1333 6.18261C5.1333 5.44823 5.69082 4.88888 6.54361 4.88888C7.39639 4.88888 7.92155 5.44823 7.93773 6.18261ZM16.7637 11.695L16.7636 15.9895H14.2708V11.9824C14.2708 10.9759 13.9101 10.2891 13.0077 10.2891C12.319 10.2891 11.9088 10.7521 11.7286 11.1993C11.6627 11.3595 11.6465 11.5829 11.6465 11.8067V15.9897H9.15339C9.15339 15.9897 9.18624 9.20257 9.15339 8.49976H11.6465V9.56065C11.9774 9.05066 12.57 8.32368 13.8935 8.32368C15.5339 8.32368 16.7637 9.39441 16.7637 11.695Z" fill="#ffffff"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcLinkedIn);